<template>
  <div>
    <div>
      <!-- <div
        class="application-cards w-100 text-center"
        v-b-modal.hire3x-AI-loader
      >
        <div>
          <img src="../../assets/new-kanban-icons/AI-icon.svg" alt="" />
        </div>
        <div class="ai-number-font">10 / 100</div>
        <div class="sorted-font">Sorted</div>
        <div class="common-progress-bar mt-1">
          <b-progress :value="value" :max="max"></b-progress>
        </div>
      </div> -->
      <div class="mt-2 application-cards w-100 text-center">
        <section>
          <div class="mt-1 d-flex align=items-center justify-content-center">
            <img
              src="../../assets/new-kanban-icons/application-img.svg"
              class="mr-1"
              alt=""
            />
            <div class="app-font-14px">
              {{ jobStats.applied ? jobStats.applied : 0 }}
            </div>
          </div>
          <div class="application-black-font">
            <div class="app-font-11px style-italic">Applied</div>
          </div>
        </section>
        <hr />
        <section>
          <div class="d-flex align=items-center justify-content-center">
            <img
              src="../../assets/new-kanban-icons/qualified.svg"
              class="mr-1"
              alt=""
            />
            <div class="app-font-14px">
              {{ jobStats.qualified ? jobStats.qualified : 0 }}
            </div>
          </div>
          <div class="application-black-font">
            <div class="app-font-11px style-italic">Qualified</div>
          </div>
        </section>
        <hr />
        <section>
          <div class="d-flex align=items-center justify-content-center">
            <img
              src="../../assets/new-kanban-icons/rejected.svg"
              class="mr-1"
              alt=""
            />
            <div class="app-font-14px">
              {{ jobStats.rejected ? jobStats.rejected : 0 }}
            </div>
          </div>
          <div class="application-black-font">
            <div class="app-font-11px style-italic">Rejected</div>
          </div>
        </section>
      </div>
      <div class="mt-3 application-cards w-100 text-center">
        <div class="app-font-12px mt-1">
          <div class="application-black-font">
            {{ jobStats.applied ? jobStats.applied : 0 }}
          </div>
          <div class="application-black-font app-font-11px style-italic">
            Total Applications
          </div>
        </div>

        <hr />
        <div class="app-font-12px mt-3">
          <div class="application-black-font">
            {{
              jobStats.registrationsApplicationCount
                ? jobStats.registrationsApplicationCount
                : 0
            }}
          </div>

          <div class="application-grey-font">Registration Link</div>
        </div>

        <hr />

        <div class="app-font-12px">
          <div class="application-black-font">
            {{
              jobStats.hire3xPlatformApplicationCount
                ? jobStats.hire3xPlatformApplicationCount
                : 0
            }}
          </div>

          <div class="application-grey-font">Hire3x Platform</div>
        </div>

        <hr />
        <div class="app-font-12px">
          <div class="application-black-font">
            {{
              jobStats.careersApplicationCount
                ? jobStats.careersApplicationCount
                : 0
            }}
          </div>

          <div class="application-grey-font">Careers Platform</div>
        </div>
      </div>
    </div>
    <b-modal
      id="hire3x-AI-loader"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <main>
        <header class="pt-3 px-3">
          <section class="d-flex align-items-center justify-content-end w-100">
            <img
              src="../../assets/panelist/blue_cross.svg"
              alt=""
              class="pointer rotate-on-hover"
            />
          </section>
        </header>
        <body class="p-4">
          <section class="d-flex w-100">
            <section
              class="
                application-cards
                mt-0
                mr-2
                d-flex
                align-items-center
                justify-content-center
                flex-column
              "
              style="width: 33.33%; height: 100px"
            >
              <div>
                <img
                  src="../../assets/new-kanban-icons/big-AI-icon.svg"
                  alt=""
                />
              </div>
              <div class="filtering-font mt-1">Profile Filtering</div>
            </section>
            <section
              class="
                application-cards
                mt-0
                mr-2
                d-flex
                align-items-center
                justify-content-center
              "
              style="width: 33.33%; height: 100px"
            >
              <div>
                <img
                  src="../../assets/new-kanban-icons/application-img.svg"
                  alt=""
                  class="mr-2"
                />
              </div>
              <div>
                <div class="ai-number-font">10/100</div>
                <div class="sorted-font">Sorting..</div>
              </div>
            </section>
            <section style="width: 33.33%">
              <div
                class="
                  application-cards
                  mt-0
                  w-100
                  text-center
                  d-flex
                  align-items-center
                "
              >
                <div>
                  <img
                    src="../../assets/new-kanban-icons/qualified.svg"
                    alt=""
                    class="mr-2"
                  />
                </div>
                <div class="application-black-font d-flex align-items-center">
                  <div class="app-font-14px mr-1"><strong> 5 </strong></div>
                  <div class="app-font-11px style-italic mt-1">Qualified</div>
                </div>
              </div>
              <div
                class="
                  application-cards
                  w-100
                  text-center
                  mt-2
                  d-flex
                  align-items-center
                "
              >
                <div>
                  <img
                    src="../../assets/new-kanban-icons/rejected.svg"
                    alt=""
                    class="mr-2"
                  />
                </div>
                <div class="application-black-font d-flex align-items-center">
                  <div class="app-font-14px mr-1"><strong> 5 </strong></div>
                  <div class="app-font-11px style-italic mt-1">Rejected</div>
                </div>
              </div>
            </section>
          </section>
          <section class="mt-3">
            <div class="common-progress-bar mt-1">
              <b-progress
                :value="value"
                :max="max"
                class="w-100"
                style="height: 10px"
              ></b-progress>
            </div>
          </section>
          <section class="mt-3 candidates-font">Candidates:</section>
          <section class="common-white-card candidates-overflow pr-1">
            <b-card class="my-2" v-for="ind in 30" :key="ind">
              <section class="w-100">
                <div class="w-100 d-flex align-items-center">
                  <div class="w-10">
                    <b-avatar
                      size="30px"
                      style="box-shadow: 0px 0px 4.67px 0px #00000040"
                    ></b-avatar>
                  </div>
                  <div class="w-90 d-flex align-items-center">
                    <div class="platform-container-head w-60">John Doe</div>
                    <div
                      class="w-40 d-flex align-items-center justify-content-end"
                    >
                      <img
                        src="@/assets/new-createjobs/delete-icon.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                <div class="w-100 d-flex align-items-center">
                  <div class="w-10"></div>
                  <div class="w-90">
                    <div class="platform-container-subhead">
                      <img
                        src="../../assets/img/newkanban/mail.svg"
                        class="mr-2"
                        alt=""
                      />
                      jennifer.martinez@simplify3x.com
                    </div>
                    <div class="w-100 d-flex align-items-center">
                      <div class="platform-container-subhead w-60">
                        <img
                          src="../../assets/img/newkanban/phone.svg"
                          class="mr-2"
                          alt=""
                        />
                        8006956622
                      </div>
                      <div
                        class="
                          w-40
                          d-flex
                          align-items-center
                          justify-content-end
                        "
                      >
                        <div class="kanban-maincards-nottriggered">pending</div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </b-card>
          </section>
        </body>
      </main>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "Application",
  data() {
    return {
      value: 45,
      max: 100,
    };
  },
  props: {
    jobStats: Object,
  },
};
</script>
<style scoped>
.style-italic {
  font-style: italic;
}
</style>
